export interface ICicaafGeneralData {
  cicaaf_uuid: string // UUID do CICAAF
  entity_type: ECicaafTipoEntidade
  isCpf: boolean
  identification: string // CPF or CNPJ
  entity_name: string
  city: string
  has_active_caf: boolean | null
  cnpj_status: ECicaafSituacaoCadastral | null
  location_type: ELocalizacaoUnidade | null
  belongs_to_association_cooperative: boolean | null // Does the agribusiness belong to any association or cooperative?
  parent_association_cooperative_uuid: "uuid" | null // If “Yes”, show dropdown with list of associations/cooperatives (fetched from API)
  // adiciona o uuid do item
}

export enum ELocalizacaoUnidade {
  RURAL_ZONE = 'ZONA RURAL',
  URBAN_ZONE = 'ZONA URBANA',
}

export enum ECicaafTipoEntidade {
  COOPERATIVE = 'COOPERATIVA',
  ASSOCIATION = 'ASSOCIAÇÃO',
  AGROINDUSTRY = 'AGROINDÚSTRIA',
}

export enum ECicaafSituacaoCadastral {
  ACTIVE = 'ATIVA',
  SUSPENDED = 'SUSPENSA',
  UNFIT = 'INAPTA',
  ACTIVE_NOT_REGULAR = 'ATIVA NÃO REGULAR',
  CLOSED = 'BAIXADA',
  NULL = 'NULA',
}

export enum CicaafCollectionStatusEnum {
  COLLECTING_WEB = 'EM COLETA (WEB)',
  COLLECTING_INCOMPLETE = 'EM COLETA (INCOMPLETO)',
  SYNCHRONIZED = 'SINCRONIZADO',
  VALIDATED_BY_MUNICIPALITY = 'VALIDADO PELO MUNICÍPIO',
  SENT_TO_STATE = 'ENVIADO AO ESTADO',
  RETURNED_BY_STATE = 'DEVOLVIDO PELO ESTADO',
  PROCESS_FINISHED = 'PROCESSO FINALIZADO',
}

export const getCicaafCollectionStatusValues = (): string[] => Object.values(CicaafCollectionStatusEnum);

export const createICicaafGeneralData = (): ICicaafGeneralData => ({
  cicaaf_uuid: '00000000-0000-0000-0000-000000000000',
  entity_type: ECicaafTipoEntidade.COOPERATIVE,
  isCpf: true,
  identification: '00000000000',
  entity_name: 'Nome Teste',
  city: 'Cidade Teste',
  has_active_caf: null,
  cnpj_status: null,
  location_type: ELocalizacaoUnidade.RURAL_ZONE,
  belongs_to_association_cooperative: null,
  parent_association_cooperative_uuid: null,
});
